import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Login.vue'



import pending_request from '../views/home/pending_request.vue'
import Doctor_dashboard from '../views/home/Doctor_dashboard.vue'
import medical from '../views/home/medical.vue'
// import First_page from '../views/home/First_page.vue'
import Appointment from '../views/home/Appointment.vue'
import Buy_Animal from '../views/home/Buy_Animal.vue'
import buy_animals from '../views/buy_animals.vue'
import my_animals from '../views/my_animals.vue'
import transport_certificate from '../views/home/transport_certificate.vue'
import view_medical from '../views/home/view_medical.vue'
import Add_for_sell from '../views/home/Add_for_sell.vue'




import Buyer from '../views/Buyer.vue'
import TransportCertificate from '../views/TransportCertificate.vue'
import InquiryList from '../views/InquiryList.vue'
import ProductDetails from '../views/ProductDetails.vue'
import CertificateApproval from '../views/CertificateApproval.vue'

import Dashboard from '../views/Dashboard.vue'
import Add_animal from '../views/Add_animal.vue'
import CowDetails from '../views/CowDetails.vue'
import OxDetails from '../views/OxDetails.vue'
import GoatDetails from '../views/GoatDetails.vue'
import BuffeloDetails from '../views/BuffeloDetails.vue'
import CowViewDetails from '../views/Cowviewdetails.vue'
import OxViewDetails from '../views/Oxviewdetails.vue'
import GoatViewDetails from '../views/Goatviewdetails.vue'
import BuffeloViewDetails from '../views/Buffeloviewdetails.vue'
import myCowViewDetails from '../views/myCowviewdetails.vue'
import myOxViewDetails from '../views/myOxviewdetails.vue'
import myGoatViewDetails from '../views/myGoatviewdetails.vue'
import myBuffeloViewDetails from '../views/myBuffeloviewdetails.vue'
import farmer_profile from '../views/farmer_profile.vue'

import view_Appointment from '../views/home/view_Appointment.vue'
import doctor_profile from '../views/home/doctor_profile.vue'
import my_area from '../views/home/my_area.vue'
import Appointment_list from '../views/home/Appointment_list.vue'
import transport_list from '../views/home/transport_list.vue'
//import Login from '../views/home/Login.vue'
import nearby_doctor from '../views/home/nearby_doctor.vue'
import change_password from '../views/home/change_password.vue'
import req_certificate from '../views/home/req_certificate.vue'
import viewmedical_certificate from '../views/home/viewmedical_certificate.vue'
import View_Transport from '../views/home/View_Transport.vue'
import pending_req from '../views/home/pending_req.vue'
import add_vaccination from '../views/home/add_vaccination.vue'
import add_insurance from '../views/home/add_insurance.vue'









Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/home/pending_request',
    name: 'pending_request',
    component: pending_request
  },
  {
    path: '/home/Doctor_dashboard',
    name: 'Doctor_dashboard',
    component: Doctor_dashboard
  },
  {
    path: '/home/medical',
    name: 'medical',
    component: medical 
  },
  // {
  //   path: '/home/First_page ',
  //   name: 'First_page ',
  //   component: First_page 
  // },
  {
    path: '/home/Appointment',
    name: 'Appointment',
    component: Appointment 
  },
 
  {
    path: '/buy_animals',
    name: 'buy_animals',
    component: buy_animals 
  },
  {
    path: '/my_animals',
    name: 'my_animals',
    component: my_animals 
  },
  {
    path: '/home/transport_certificate',
    name: 'transport_certificate',
    component: transport_certificate 
  },
  {
    path: '/home/view_medical',
    name: 'view_medical',
    component: view_medical 
  },
  {
    path: '/home/view_Appointment',
    name: 'view_Appointment',
    component: view_Appointment
  },
  {
    path: '/home/doctor_profile',
    name: 'doctor_profile',
    component: doctor_profile
  },
  {
    path: '/home/my_area',
    name: 'my_area',
    component: my_area
  },
  {
    path: '/home/Appointment_list',
    name: 'Appointment_list',
    component: Appointment_list
  },
  {
    path: '/home/transport_list',
    name: 'transport_list',
    component: transport_list
  },
  // {
  //   path: '/home/Login',
  //   name: 'Login',
  //   component: Login
  // },
  {
    path: '/home/nearby_doctor',
    name: 'nearby_doctor',
    component: nearby_doctor
  },
  {
    path: '/home/change_password',
    name: 'change_password',
    component: change_password
  },
  {
    path: '/home/Add_for_sell',
    name: 'Add_for_sell',
    component: Add_for_sell
  },
  {
    path: '/home/req_certificate',
    name: 'req_certificate',
    component: req_certificate
  },
  {
    path: '/home/viewmedical_certificate',
    name: 'viewmedical_certificate',
    component: viewmedical_certificate
  },
  {
    path: '/home/View_Transport',
    name: 'View_Transport',
    component: View_Transport
  },
  {
    path: '/home/pending_req',
    name: 'pending_req',
    component: pending_req
  },
  {
    path: '/home/add_vaccination',
    name: 'add_vaccination',
    component: add_vaccination
  },
  {
    path: '/home/add_insurance',
    name: 'add_insurance',
    component: add_insurance
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/add_animal',
    name: 'Animal',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Add_animal.vue')
  },
  {
    path: '/farmer_profile',
    name: 'Farmer',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/farmer_profile.vue')
  },
  {
    path: '/buyer',
    name: 'Buyer',
    component: Buyer
  },
  {
    path: '/transportcertificate',
    name: 'TransportCertificate',
    component: TransportCertificate
  },
  {
    path: '/inquirylist',
    name: 'InquiryList',
    component: InquiryList
  },
  {
    path:'/cowdetails',
    name:'CowDetails',
    component: CowDetails
  },
  {
    path:'/oxdetails',
    name:'OxDetails',
    component: OxDetails
  },
  {
    path:'/goatdetails',
    name:'GoatDetails',
    component: GoatDetails
  },
  {
    path:'/buffelodetails',
    name:'BuffeloDetails',
    component: BuffeloDetails
  },
  {
    path:'/Cowviewdetails',
    name:'CowViewDetails',
    component: CowViewDetails
  },
  {
    path:'/Oxviewdetails',
    name:'OxViewDetails',
    component: OxViewDetails
  },
  {
    path:'/Goatviewdetails',
    name:'GoatViewDetails',
    component: GoatViewDetails
  },
  {
    path:'/Buffeloviewdetails',
    name:'BuffeloViewDetails',
    component: BuffeloViewDetails
  },
  {
    path:'/myCowviewdetails',
    name:'myCowViewDetails',
    component: myCowViewDetails
  },
  {
    path:'/myOxviewdetails',
    name:'myOxViewDetails',
    component: myOxViewDetails
  },
  {
    path:'/myGoatviewdetails',
    name:'myGoatViewDetails',
    component: myGoatViewDetails
  },
  {
    path:'/myBuffeloviewdetails',
    name:'myBuffeloViewDetails',
    component: myBuffeloViewDetails
  },
  {
    path: '/productdetails',
    name: 'ProductDetails',
    component: ProductDetails
  },
  {
    path: '/certificateapproval',
    name: 'CertificateApproval',
    component: CertificateApproval
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
